import React, { useEffect, useRef, useState } from "react";
import HeaderCustom from "../../../components/HeaderCustom";
import { Alert, Backdrop, CircularProgress, Snackbar } from "@mui/material";
import { useLocation, useParams, useSearchParams } from 'react-router-dom';
import { useSelector } from "react-redux";
import logoPaseo from "../../../assets/imagenes/splash.png";
import grafismoPaseo from "../../../assets/imagenes/grafismo-paseo2.png";
import { getDetalleSorteo, postGuardarGanadorSorteo, postSortear } from "../../../api/ApiService";


function SorteadorPage() {
    const [cargando, setCargando] = useState(false);
    const [loadingGuardar, setLoadingGuardar] = useState(false);
    const [numeroCupon, setNumeroCupon] = useState("0");
    const [detalleSorteo, setDetalleSorteo] = useState(null);
    const [isSorteando, setIsSorteando] = useState(false);
    const [datosGanador, setDatosGanador] = useState(null);

    const intervalRef = useRef(null);
    const timeoutRef = useRef(null);

    const [open, setOpen] = useState(false);
    const [severity, setSeverity] = useState('');
    const [mensaje, setMensaje] = useState('');



    const stateToken = useSelector(state => state.reducerGlobal.token);
    const location = useLocation();

    const params = useParams();
    const { id } = params;

    const [searchParams] = useSearchParams();
    const mode = searchParams.get("mode");








    //==========================================================funcion para enviar encuesta a la api
    const handleDetalleSorteo = () => {
        getDetalleSorteo(id, stateToken?.access_token)
            .then(response => {
                // console.log("getDetalleEvento", response);
                setCargando(true);

                setDetalleSorteo(response?.data);
                setNumeroCupon(String(response?.data?.numero_cupon || "0"));

            })
            .catch(error => {
                console.log("error-getDetalleEvento", error);
                setCargando(false);
                setDetalleSorteo(null);

                setMensaje("Error al cargar los datos");
                setSeverity('error');
                setOpen(true);
            })
    }

    useEffect(() => {
        if (id) {
            if (stateToken) {
                handleDetalleSorteo();
            }
        } else {
            setTimeout(() => {
                setCargando(true);
            }, 1000);
        }
    }, [id, stateToken]);

    useEffect(() => {
        return () => {
            limpiarTemporizadoresSorteo();
        };
    }, []);





    //=========================================================cerrar modal de alerta
    const handleClose = () => {
        setOpen(false);
    };


    //========================================================== api para sortear
    const handleApiGuardarGanador = (id, cupon) => {

        let body = {
            tipo_sorteo: mode === 'prueba' ? 'prueba' : 'real',
            sorteo_especial: false,
            nro_cupon: cupon
        };


        postGuardarGanadorSorteo(stateToken?.access_token, body, id)
            .then(response => {
                // console.log("postGuardarGanadorSorteo", response);
                setDatosGanador(response?.data);

            })
            .catch(error => {
                console.log("error-postGuardarGanadorSorteo", error);

            })
    };

    //========================================================== api para sortear
    const handleApiSortear = (ultimoNumero) => {

        let body = {
            tipo_sorteo: mode === 'prueba' ? 'prueba' : 'real',
            sorteo_especial: false
            // numero_cupon: numeroCupon
        };


        postSortear(stateToken?.access_token, body, id)
            .then(response => {
                // console.log("postSortear", response);
                setDatosGanador(response?.data);
                handleApiGuardarGanador(id, response?.data?.cupon_ganador);

                limpiarTemporizadoresSorteo();
                setNumeroCupon(response?.data?.cupon_ganador);
                setIsSorteando(false);
            })
            .catch(error => {
                console.log("error-postSortear", error);
                setIsSorteando(false);
                setMensaje("Error al realizar el sorteo");
                setSeverity('error');
                setOpen(true);
            })
    };

    const generarNumeroAleatorio = () => {
        // Numero aleatorio con maximo de 5 digitos (0 a 99999)
        return String(Math.floor(Math.random() * 100000));
    };

    const limpiarTemporizadoresSorteo = () => {
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }

        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
    };




    const handleInciarSorteo = () => {
        if (isSorteando) return;

        setIsSorteando(true);
        let ultimoNumero = generarNumeroAleatorio();
        setNumeroCupon(ultimoNumero);

        intervalRef.current = setInterval(() => {
            ultimoNumero = generarNumeroAleatorio();
            setNumeroCupon(ultimoNumero);
        }, 90);
        handleApiSortear(ultimoNumero);

        // timeoutRef.current = setTimeout(() => {
        //     limpiarTemporizadoresSorteo();
        //     setNumeroCupon(ultimoNumero);
        //     setIsSorteando(false);
        // }, 2500);
    };







    return (
        <HeaderCustom>
            <div className="min-h-screen bg-[#c9ced7] p-4 sm:p-6 md:p-10">
                <div className="mx-auto max-w-3xl">

                    {cargando ? (
                        <div className="overflow-hidden bg-white shadow-[0_20px_50px_rgba(15,23,42,0.12)]">
                            <div className="mx-auto flex min-h-[690px] max-w-[800px] flex-col items-center px-6 pb-0 pt-12 text-center sm:px-10">
                                <img
                                    src={logoPaseo}
                                    alt="Paseo La Galeria"
                                    className="mb-12 w-[170px] object-contain sm:w-[190px]"
                                />

                                <div className="space-y-1">
                                    <h1 className="text-4xl font-bold tracking-[-0.03em] text-[#3f4047] sm:text-5xl">
                                        {detalleSorteo?.titulo || "N/A"}
                                    </h1>
                                </div>

                                <div className="mt-14 w-full max-w-[420px]">
                                    {mode === 'prueba' && (
                                        <div className="mb-8 px-4 py-2 rounded-lg bg-red-50 border border-red-200">
                                            <label
                                                className="mb-1.5 block text-sm font-semibold text-red-700"
                                            >
                                                SORTEO DE PRUEBA
                                            </label>
                                        </div>
                                    )}

                                    {datosGanador && (
                                        <div className="mb-8 px-4 py-2 rounded-lg bg-green-50 border border-green-200">
                                            <label
                                                className="mb-1.5 block text-sm font-semibold text-green-700"
                                            >
                                                GANADOR: {datosGanador?.usuario_ganador?.nombre || "N/A"}
                                            </label>
                                            <p className="text-sm text-green-700">
                                                C.i: ****{datosGanador?.usuario_ganador?.ci || "N/A"}
                                            </p>
                                        </div>
                                    )}


                                    <div className="h-14 w-full rounded-2xl border border-[#cdd5df] bg-white px-5 text-center text-lg text-[#3f4047] outline-none transition focus:border-[#194e7a] focus:ring-4 focus:ring-[#194e7a]/10 flex items-center justify-center">
                                        <span className="text-[#3f4047]">{numeroCupon}</span>
                                    </div>

                                    <button
                                        type="button"
                                        onClick={handleInciarSorteo}
                                        disabled={isSorteando}
                                        className="mt-12 h-14 w-full rounded-2xl bg-[#0d4a73] text-2xl font-semibold text-white mb-6 transition hover:bg-[#0b4063]"
                                    >
                                        {isSorteando ? "Sorteando..." : "Iniciar Sorteo"}
                                    </button>
                                </div>

                                <div className="mt-auto w-[calc(100%+3rem)] sm:w-[calc(100%+5rem)] ">
                                    <img
                                        src={grafismoPaseo}
                                        alt="Grafismo Paseo"
                                        className="h-[66px] w-full object-cover object-center"
                                    />
                                </div>
                            </div>
                        </div>
                    ) :
                        (
                            <div className="bg-white rounded-xl shadow-md p-8">
                                <div className="h-6 bg-gray-200 rounded w-1/3 mb-6 animate-pulse" />
                                <div className="space-y-4">
                                    <div className="h-10 bg-gray-200 rounded animate-pulse" />
                                    <div className="h-10 bg-gray-200 rounded animate-pulse" />
                                    <div className="h-24 bg-gray-200 rounded animate-pulse" />
                                </div>
                            </div>
                        )
                    }
                </div>
            </div>

            <Backdrop open={loadingGuardar} sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}>
                <CircularProgress color="inherit" />
            </Backdrop>

            <Snackbar open={open} autoHideDuration={2000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={severity} elevation={6} variant="filled" >
                    {mensaje}
                </Alert>
            </Snackbar>
        </HeaderCustom>
    );
}

export default SorteadorPage;